const plusIcon = `<svg focusable="false" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M10 4H8V8H4V10H8V14H10V10H14V8H10V4Z" fill="#00A3E0" />
</svg>
`;

export default plusIcon;
